import React from "react";
import { Row, Col, Button, Tabs, Form } from "antd";
import isFunction from "lodash/isFunction";
import isEmpty from "lodash/isEmpty";
import {
  getParamsByConditions,
  getComponent
} from "../../wea-tools/getComponent";
import { callApi } from "../../wea-tools/callApi";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaSelect from "../../wea-select";
import Search from "../search";
import WeaTools from "../../wea-tools";
import WeaFormItem from "../../wea-form-item";
import WeaInputSearch from "../../wea-input-search";

const { TabPane } = Tabs;
const { getLabel } = WeaLocaleProvider;

// 获取高级搜索
export function getConditions(cb) {
  const { conditionURL, type, conditionDataParams, onError } = this.props;
  callApi(`${conditionURL}${type}`, "GET", conditionDataParams)
    .then(data => {
      if (!isEmpty(data.conditions)) {
        const newState = {};
        let quickSearch = "";
        data.conditions.forEach(item => {
          if (item.isQuickSearch) {
            quickSearch = item.domkey[0];
            newState.quickSearch = quickSearch;
          }
        });
        const params = getParamsByConditions(data.conditions);
        this.defaultConditionParams = { ...params };
        const { setFieldsValue, resetFields } = this.props.form;
        resetFields();
        if (!isEmpty(params)) {
          setFieldsValue(params);
          if (params[quickSearch]) {
            newState.inputValue = params[quickSearch];
          }
          if (params.date2during) {
            newState.date2during = params.date2during;
          }
        }
        this.setState(
          {
            ...newState,
            browserConditions: data.conditions,
            showSearchAd: false
          },
          () => {
            cb && cb(params);
          }
        );
      } else {
        cb && cb({});
      }
      if (this.isCrm()) {
        this.getVirtual();
      }
    })
    .catch(e => isFunction(onError) && onError(e));
}

export function getTabsFromUrl(callback) {
  const { tabsUrl, tabsParams, type, onError, extendTabs = [] } = this.props;
  const tabs = this.getTabs();
  if (tabsUrl && isEmpty(tabs)) {
    callApi(`${tabsUrl}${type}`, "get", tabsParams)
      .then(res => {
        let { datas } = res;
        if (isEmpty(datas) && this.isCrm()) {
          datas = [
            {
              name: getLabel(24515, "最近"),
              key: "1"
            },
            {
              name: getLabel(18511, "同部门"),
              key: "2"
            },
            {
              name: getLabel(15089, "我的下属"),
              key: "3"
            },
            {
              name: getLabel(18770, "按组织结构"),
              key: "4"
            },
            {
              name: getLabel(81554, "常用组"),
              key: "5"
            },
            ...extendTabs
          ];
        }
        this.setState({ tabsFromApi: datas }, callback);
      })
      .catch(e => isFunction(onError) && onError(e));
  } else {
    callback && callback();
  }
}

export function getTabs() {
  const { tabs, defualtTabs, extendTabs = [] } = this.props;
  const { tabsFromApi } = this.state;
  let defualtDatas = defualtTabs && defualtTabs.length ? defualtTabs : [];
  defualtDatas = [...defualtDatas, ...extendTabs];
  if (!isEmpty(tabs)) {
    return tabs;
  } else if (!isEmpty(defualtDatas)) {
    return defualtDatas;
  } else {
    return tabsFromApi;
  }
}

export function getDefaultActiveKey(isDefault = true) {
  // 获取默认的tab
  const tabs = this.getTabs();
  if (Array.isArray(tabs) && !isEmpty(tabs)) {
    return (
      tabs.filter(tab => (isDefault ? tab.selected : tab.isSearch))[0] ||
      tabs[0]
    ).key;
  }
  return "";
}

export function getActionTab() {
  const tabs = this.getTabs();
  if (!isEmpty(tabs)) {
    return (
      <Tabs activeKey={this.state.activeKey} onChange={this.onTabChange}>
        {tabs.map(
          tab =>
            (!this.isCrm() || (this.isCrm() && tab.key != "6")) && (
              <TabPane tab={tab.name} key={tab.key} />
            )
        )}
      </Tabs>
    );
  }
  return null;
}

export function onTabChange(activeKey) {
  this.setState({ activeKey }, () => this.onSearch({}, activeKey));
}

// 获取高级搜索表单内容
export function getActionSearchAd() {
  const { isSingle, isMultCheckbox } = this.props;
  const { browserConditions } = this.state;
  const items = browserConditions.map(field => {
    const style = WeaTools.isComponentHide(field) ? { display: "none" } : null;
    return (
      <Col
        className="wea-form-cell"
        span={24 / (isSingle || isMultCheckbox ? field.colSpan || 2 : 1)}
        style={style}
      >
        <WeaFormItem
          label={`${field.label}`}
          labelCol={{ span: `${field.labelcol}` }}
          wrapperCol={{ span: `${field.fieldcol}` }}
          viewAttr={field.viewAttr}
        >
          {getComponent(
            field.conditionType,
            field.browserConditionParam,
            field.domkey,
            this.props,
            field
          )}
        </WeaFormItem>
      </Col>
    );
  });
  return (
    <div className="wea-search-group">
      <Row className="wea-content">{items}</Row>
    </div>
  );
}

// 重置高级搜索条件
export function reset() {
  const { getFieldValue, resetFields, setFieldsValue } = this.props.form;
  const { browserConditions } = this.state;
  const quickSearch = this.state.quickSearch || "name";
  const params = getParamsByConditions(browserConditions);
  if (getFieldValue(quickSearch)) {
    this.setState({ inputValue: "" });
  }
  resetFields();
  setFieldsValue(params);
}

// 获取高级搜索的操作按钮
export function getActionButtonsAd() {
  return [
    <Button
      type="primary"
      onClick={() => {
        const { hasLeftTree, leftToSearchKey } = this.props;
        if (hasLeftTree) {
          // 左侧树选中受控
          const params = this.getSearchParams();
          if (params[leftToSearchKey]) {
            this.setState({ leftSelectKeys: [params[leftToSearchKey]] });
          }
        }
        this.onSearch();
        this.setState({ showSearchAd: false });
      }}
    >
      {getLabel(197, "搜索")}
    </Button>,
    <Button type="ghost" onClick={() => this.reset()}>
      {getLabel(2022, "重置")}
    </Button>,
    <Button type="ghost" onClick={() => this.setState({ showSearchAd: false })}>
      {getLabel(31129, "取消")}
    </Button>
  ];
}

export function onSearchChange(v) {
  this.setState({ inputValue: v });
  const { form } = this.props;
  const { quickSearch } = this.state;
  if (form && quickSearch) {
    form.setFieldsValue({ [quickSearch]: v });
  }
}

// 获取穿梭框左侧的高级搜索和下拉框
export function getActionBarInTrans(showInputSearch = true) {
  const { hideAdvanceSearch, type } = this.props;
  const { showSearchAd, inputValue, contentType } = this.state;
  let buttonAd = null;
  let dropContent = null;
  const isTree = contentType == 3 && type != 142;
  if (!hideAdvanceSearch) {
    buttonAd = (
      <Col span={6}>
        <Button
          className="wea-workflow-serch-condition"
          type="ghost"
          onClick={() => this.setState({ showSearchAd: true })}
        >
          {getLabel(347, "高级搜索")}
        </Button>
      </Col>
    );
    const buttons = this.getActionButtonsAd().map(b => (
      <span style={{ marginLeft: 15 }}>{b}</span>
    ));
    dropContent = (
      <div
        className="wea-search-wrap"
        style={{ display: showSearchAd && !isTree ? "block" : "none" }}
      >
        <Button
          type="ghost"
          className="wea-advanced-search"
          onClick={() => this.setState({ showSearchAd: false })}
        >
          {getLabel(347, "高级搜索")}
        </Button>
        <div className="wea-advanced-searchs">
          <Form horizontal>
            {this.getActionSearchAd()}
            <div className="wea-search-buttons">
              <div style={{ textAlign: "center" }}>{buttons}</div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
  const search = showInputSearch ? (
    <Row
      style={{
        height: 35
        // position: isTree ? "fixed" : "relative",
        // visibility: isTree ? "hidden" : "visible"
      }}
    >
      <Col span={hideAdvanceSearch ? 24 : 18}>
        <WeaInputSearch
          placeholder=""
          value={inputValue}
          onSearchChange={this.onSearchChange}
          onSearch={() => this.onSearch()}
        />
      </Col>
      {buttonAd}
    </Row>
  ) : null;
  return [search, dropContent];
}

// 获取搜索类型
export function getActionSearchType() {
  const { quickSearch } = this.state;
  const { isSingle, hasAdvanceSerach, isMultCheckbox } = this.props;
  if (!isSingle && !isMultCheckbox) return [];
  if (this.isCrm()) return ["base", "advanced"];
  return [quickSearch && "base", hasAdvanceSerach && "advanced"].filter(
    Boolean
  );
}

export function onSelectChange(date2during) {
  const { form } = this.props;
  if (form) {
    form.setFieldsValue({ date2during });
  }
  this.setState({ date2during }, () => this.onSearch());
}

// 获取搜索框
export function getActionBar() {
  const { isSingle, type, hasAdvanceSerach, isMultCheckbox } = this.props;
  const {
    browserConditions,
    date2during,
    quickSearch,
    inputValue,
    showSearchAd
  } = this.state;
  const tab = this.getActionTab();
  const select = () => {
    let options = [];
    let viewAttr = "2";
    browserConditions &&
      browserConditions.forEach(m => {
        if (m.domkey[0] == "date2during") {
          options = m.options;
          if (m.viewAttr) viewAttr = m.viewAttr;
        }
      });
    if (options.length > 0) {
      return (
        <WeaSelect
          viewAttr={viewAttr}
          style={{ width: "100px" }}
          value={date2during}
          options={options}
          onChange={this.onSelectChange}
        />
      );
    }
    return null;
  };
  let addSelect = type == "152" || type == "171";
  if (isSingle) {
    addSelect = type == "16";
  }
  if (
    tab ||
    isMultCheckbox ||
    (isSingle && (hasAdvanceSerach || quickSearch || this.isCrm()))
  ) {
    return (
      <Search
        buttonsAd={this.getActionButtonsAd()}
        addSelect={addSelect ? select() : ""}
        tabs={tab}
        searchType={this.getActionSearchType()}
        searchsBaseValue={inputValue}
        searchsAd={<Form horizontal>{this.getActionSearchAd()}</Form>}
        showSearchAd={(isSingle || isMultCheckbox) && showSearchAd}
        setShowSearchAd={bool => this.setState({ showSearchAd: bool })}
        onSearchChange={this.onSearchChange}
        onSearch={() => this.onSearch()}
      />
    );
  }
  return null;
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/getSearch.js